<script setup>
const { isDarkMode } = useDarkMode()

const { AnalyticsEvent, track } = useAnalytics()
const props = defineProps({
  tech: {
    type: Object,
    required: true
  }
})

const user = useUser()
const ui = useUi()
const { getFlashMessageKey } = useHelpers()

const votesModel = ref(user.data?.metadata?.interest || [])
const votes = computed(() => user.data?.metadata?.interest || [])

watch(() => ([votes.value, user.data?.metadata?.interest]), () => {
  votesModel.value = votes.value
}, { immediate: true })

async function vote () {
  const payload = {
    slug: 'what-certifications-do-you-want',
    votes: [{ value: props.tech.id }]
  }

  user.addToQueue({ method: 'castVote', payload })
  track(AnalyticsEvent.VOTE)

  if (user.isGuest) {
    ui.flashMessageKey = getFlashMessageKey()
    ui.openAuthModal()
  }
}

const techTheme = useTechTheme()
const currentTheme = computed(() => techTheme.lowestLevelTheme.value)
</script>

<template>
  <label
    :key="tech.id"
    class="group flex w-full cursor-pointer justify-between gap-4 rounded-2xl border p-6 ring-eerie-black hover:ring-1 dark:ring-light-gray"
    :class="[
      {
        'border-2bg-white pointer-events-none dark:bg-eerie-black': votes.includes(tech.id),
        [`${currentTheme?.borderColor || 'border-azure-radiance'} dark:${currentTheme?.borderColor || 'border-azure-radiance'}`]: votes.includes(tech.id),
        'border border-transparent bg-eerie-black/5 dark:bg-dark-gunmetal': !votes.includes(tech.id),
        'pointer-events-none': tech.id === 'other',
      },
    ]"
    @click="vote">
    <div
      v-if="tech.id === 'other'">
      (INPUT UNDER REFACTORING)
      <!-- <input
        v-model="freeText"
        type="text"
        name="others"
        class="rounded-lg border-2 border-body-gray bg-transparent p-3 text-eerie-black placeholder:text-body-gray focus:outline-none dark:text-light-gray"
        placeholder="Other"> -->
    </div>
    <div
      v-else
      class="flex items-center gap-5">
      <InlineSvg
        :src="`/images/homepage/tech-${tech.id}${!isDarkMode ? '-light' : ''}.svg`"
        class="h-10 w-auto"
        :alt="tech.label" />
      <p class="heading-primary text-sm font-bold md:text-lg md:leading-tight">
        {{ tech.label }}
      </p>
    </div>

    <div
      class="group flex flex-row-reverse items-center gap-4">
      <AppLoading
        v-if="user.submittingVotes.includes(tech.id)" />
      <AppCheckbox
        v-else
        v-model="votesModel"
        :value="tech.id"
        type="checkbox"
        class="m-0"
        :checked-class="`${currentTheme?.bgColor || 'bg-azure-radiance'} border ${currentTheme?.borderColor || 'border-azure-radiance'}`" />
      <span
        class="flex-1 select-none"
        :class="[
          {
            [`${currentTheme?.textColor || 'text-azure-radiance'}`]: votes.includes(tech.id),
            'text-body-gray': !votes.includes(tech.id),
            [`group-hover:${currentTheme?.textColor || 'text-azure-radiance'} dark:group-hover:${currentTheme?.textColor || 'text-azure-radiance'}`]: true
          }
        ]">
        I'm interested
      </span>
    </div>
  </label>
</template>
